import anduPhoto from "./photos/andu.jpeg";
import baruPhoto from "./photos/baru.jpeg";
import crotalariaPhoto from "./photos/crotalaria.jpeg";
import guapuruvuPhoto from "./photos/guapuruvu.jpeg";
import jatobaPhoto from "./photos/jatoba.jpeg";
import jucaraPhoto from "./photos/jucara.jpeg";
import tamborilPhoto from "./photos/tamboril.jpeg";
import xixaPhoto from "./photos/xixa.jpeg";
import jacarePhoto from "./photos/jacare.jpeg";

export const MUVUCA_QUERY_VALUE = "TXV2dWNhOjE=";

export const muvucaSpeciesList = [
  {
    id: "TGlmZU5vZGU6MjI0ODc=",
    name: "Juçara",
    description:
      "A juçara (Euterpe edulis Mart.) é uma palmeira nativa da Mata Atlântica que podemos tirar a polpa produzindo um açaí de juçara. Ameaçada de extinção, é símbolo de resistência e protagonista do nosso projeto Circuito Juçara, de onde trazemos essas sementes. Gosta de ambientes úmidos e mais sombreados.",
    image: jucaraPhoto,
  },
  {
    id: "TGlmZU5vZGU6MjIwOTc5",
    name: "Tamboril",
    description:
      "O tamboril (Enterolobium contortisiliquum) é uma árvore da família das leguminosas, presente em diversos biomas do Brasil, como Mata Atlântica, Cerrado, Pantanal e Caatinga. É uma espécie pioneira que cresce bem em solos férteis ou medianos, mesmo em áreas degradadas, preferindo solos bem drenados.",
    image: tamborilPhoto,
  },
  {
    id: "TGlmZU5vZGU6MzM0OTc2",
    name: "Crotalária",
    description:
      "A crotalária (Crotalaria juncea L.) é uma planta muito utilizada como adubo verde, devido a melhorar a fertilidade do solo, ajudar no controle de pragas e fixação de nitrogênio. Possui crescimento rápido e funciona como uma espécie de placenta para as demais espécies.",
    image: crotalariaPhoto,
  },
  {
    id: "TGlmZU5vZGU6MjIxMjk5",
    name: "Feijão Andú",
    description:
      "O feijão guandu ou andú (Cajanus cajan) é uma leguminosa arbustiva muito resistente à seca e adaptada a solos pobres. Tem a função de fixar nitrogênio e ajudar a criar as outras espécies, além de poder ser usado na alimentação.",
    image: anduPhoto,
  },
  {
    id: "TGlmZU5vZGU6MjE4NTcw",
    name: "Jatobá",
    description:
      "O jatobá (Hymenaea courbaril L.) é uma árvore grande e imponente presente na Mata Atlântica, Cerrado e Amazônia. Sendo uma leguminosa, coletamos essas sementes na região, extraímos a farinha doce e, dessa forma, limpamos a semente.",
    image: jatobaPhoto,
  },
  {
    id: "TGlmZU5vZGU6MjE2MjQ1",
    name: "Guapuruvu",
    description:
      "O breu ou guapuruvu (Schizolobium parahyba) é uma árvore alta e de crescimento rápido, nativa da Mata Atlântica e muito usada para reflorestamento. É bem presente na beira da água — a madeira é usada para canoas — e coletada na região.",
    image: guapuruvuPhoto,
  },
  {
    id: "TGlmZU5vZGU6MjIyOTMw",
    name: "Baru",
    description:
      "O baru (Dipteryx alata Vog.) é uma árvore nativa do Cerrado brasileiro, com fruto e castanha saborosos e cada vez mais valorizados. Tem papel importante na recuperação de áreas degradadas e não gosta de regiões muito úmidas ou encharcadas.",
    image: baruPhoto,
  },
  {
    id: "TGlmZU5vZGU6MjMxMDU0",
    name: "Xixá",
    description:
      "O xixá (Sterculia apetala) é uma árvore grande do Cerrado, comum também na Amazônia. Seus frutos possuem sementes comestíveis, com gosto parecido com o amendoim. Prefere solos bem drenados e locais ensolarados, resistindo bem à seca e ao fogo.",
    image: xixaPhoto,
  },
  {
    id: "TGlmZU5vZGU6MjI5Nzcx",
    name: "Pau-jacaré",
    description:
      "O pau-jacaré (Piptadenia gonoacantha) é uma leguminosa de médio a grande porte e possui o tronco fissurado lembrando a pele de um jacaré, por isso esse nome, sendo essa semente coletada essa semente no nosso quintal agroflorestal.",
    image: jacarePhoto,
  },
];
